<template>
  <div class="content">
    <b-navbar toggleable="sm" type="dark" variant="primary" fixed="top">
      <b-navbar-brand href="/"><img src="../assets/cogvis_green.png" style="height:36px;"></b-navbar-brand>
      <!-- <b-navbar-brand href="/">{{ $t('cogvisSetup') }}</b-navbar-brand> -->

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>

        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">

          <b-nav-item target="_blank" :href="$t('installationManualLink')">{{ $t('installationManual') }}</b-nav-item>
          <b-nav-item-dropdown :text="$t('language')" right>
            <b-dropdown-item v-for="lang in langs"
                        :key="lang"
                        :value="lang"
                        @click="$root.$i18n.locale = lang">
              {{ $t(lang) }}
            </b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return { langs: ['en', 'de'] }
  },
}
</script>
